"use strict";
exports.__esModule = true;
exports.toBulleTalk = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var contact_1 = require("./contact");
var toBulleTalk = function (data, logger) {
    var prismicBulleTalk = utils_1.unprefix('bulleTalk', data);
    if (prismicBulleTalk) {
        return utils_1.compact({
            text: logger.required(fields_1.toText(prismicBulleTalk.text)),
            contact: contact_1.toContact(prismicBulleTalk, logger)
        });
    }
};
exports.toBulleTalk = toBulleTalk;
//# sourceMappingURL=bulle-talk.js.map